import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {useLavoratore} from "@commons/hooks/useLavoratoreHR";
import {selectAzienda} from "@commons/core.slice";
import AziendaNavContainer from "../../features/azienda/AziendaNavContainer";
import React, {useState} from "react";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import {LavoratoreBar} from "../../features/lavoratore/LavoratoreBar";
import {Tab} from "@headlessui/react";
import {useLazyGetSingoliElementiQuery} from "@commons/features/lavoratore/RMLLavoratore.api";
import {DettaglioRetribuzioneRecord} from "@commons/mapping/DettaglioRetribuzioneRecord";
import {useEditor} from "../../core/editor";
import {currencyFormat} from "@commons/utils/util";
import TabFlat from "./retribuzione/TabFlat";
import TabByElementi from "./retribuzione/TabByElementi";
import {toastAsError} from "@utilities/toastAsError";

export const formatImporto = (retribuzione: number | null, format: Intl.NumberFormat = currencyFormat, zeroValue: string = '-,-- €') => {
    if (retribuzione || retribuzione === 0)
        return format.format(retribuzione);
    else
        return zeroValue;
}

export interface TabProps {
    editor: ReturnType<typeof useEditor<DettaglioRetribuzioneRecord>>,
    dettagliContratto: LavoratoreRecord | null | undefined,
    retribOraria: boolean,
    toggleRetribOraria: (v: boolean) => void,
}

const LavoratoriRetribPage: React.FC<{}> = () => {
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [retribOraria, setRetribOraria] = useState<boolean>(false);

    const azienda: AziendaRecord | null = useAppSelector(selectAzienda);
    const dettagliContratto: LavoratoreRecord | null = useLavoratore(toastAsError);

    const [getTriggerFlat] = useLazyGetSingoliElementiQuery();
    const editorFlat = useEditor<DettaglioRetribuzioneRecord>(undefined, getTriggerFlat, undefined, undefined)

    const [getTriggerByElementi] = useLazyGetSingoliElementiQuery();
    const editorByElementi = useEditor<DettaglioRetribuzioneRecord>(undefined, getTriggerByElementi, undefined, undefined)

    const toggleRetribOraria = (v: boolean) => setRetribOraria(v);

    return <>
        <AziendaNavContainer>
            {azienda && <>
                <LavoratoreBar azienda={azienda}>
                    <Tab.Group selectedIndex={tabIndex} onChange={(index) => setTabIndex(index)}>
                        <Tab.List className="tab-list">
                            <Tab className="tab">Retribuzione</Tab>
                            <Tab className="tab">Analisi per elemento</Tab>
                        </Tab.List>
                        <Tab.Panels className="tab-panels">

                            <Tab.Panel unmount={false}>
                                <TabFlat editor={editorFlat}
                                         retribOraria={retribOraria}
                                         toggleRetribOraria={toggleRetribOraria}
                                         dettagliContratto={dettagliContratto}/>
                            </Tab.Panel>

                            <Tab.Panel unmount={false}>
                                <TabByElementi editor={editorByElementi}
                                               retribOraria={retribOraria}
                                               toggleRetribOraria={toggleRetribOraria}
                                               dettagliContratto={dettagliContratto}/>
                            </Tab.Panel>

                        </Tab.Panels>
                    </Tab.Group>

                </LavoratoreBar>
            </>}
        </AziendaNavContainer>
        <div data-iframe-height=""></div>
    </>
}
export default LavoratoriRetribPage;